// Batal Validasi piutang (brief owner 22 Sep 2026, B1) — logika MURNI yang
// wajib sama persis dengan backend `routers/finance/piutang.py`.
//
// Sengaja TANPA impor apa pun: berkas ini dimuat Node apa adanya oleh tes
// paritas `backend/tests/test_piutang_batal_validasi_layar.py`, yang
// menjalankan matriks kasus yang SAMA di Python dan di sini. Kalau keduanya
// berpisah jalan, tombol Setujui/Tolak akan muncul lalu berujung 403 (aturan 3
// CLAUDE.md) — atau sebaliknya, fitur yang sah tidak pernah terlihat.

// Cermin `IZIN_SPV_PIUTANG`. Update DAN delete, bukan delete saja: seluruh
// kolom Validasi hanya dirender untuk pemegang `update`, jadi pemegang Hapus
// tanpa Edit memang tidak pernah melihat tombolnya — dan backend menolaknya
// dengan kunci yang sama.
export const KUNCI_SPV_PIUTANG = [["finance_piutang", "update"], ["finance_piutang", "delete"]];

export function bolehPutuskanBatal(can) {
  return KUNCI_SPV_PIUTANG.every(([modul, aksi]) => can(modul, aksi));
}

// Cermin `_STATUS_PIUTANG_SAH`. `/validasi` dan `/validasi/ajukan-batal`
// menolak (400) piutang di luar status ini — dan status piutang bisa berpindah
// ke `dibatalkan`/`belum_diverifikasi` lewat edit nota TANPA menyentuh centang
// Valid-nya (sales.py, sinkron piutang). Tanpa pemeriksaan ini, tombol Ajukan
// batal / lepas / centang tampil pada baris seperti itu lalu selalu ditolak.
// Setujui/Tolak SENGAJA tidak memakai ini: backend tetap menerima keputusan
// atas pengajuan yang terlanjur menggantung pada piutang yang kemudian
// dibatalkan, dan tanpa tombolnya pengajuan itu tidak bisa keluar.
export const STATUS_PIUTANG_BOLEH_VALIDASI = ["aktif", "lunas"];

export function bolehUbahValidasi(piutang) {
  return STATUS_PIUTANG_BOLEH_VALIDASI.includes((piutang || {}).status);
}

const kunciEmail = (e) => (typeof e === "string" ? e.trim().toLowerCase() : "");
const kunciId = (v) => (v === null || v === undefined ? "" : String(v).trim());

/** Cermin `pengaju_sama_dengan`: sama kalau id sama ATAU email ternormalisasi
 *  sama; identitas kosong di salah satu pihak = dianggap sama (tombol Setujui
 *  disembunyikan, karena backend akan menolaknya). */
export function pengajuSama(pengajuan, user) {
  const p = pengajuan || {};
  const u = user || {};
  const uid = kunciId(u.id);
  const uem = kunciEmail(u.email);
  const pid = kunciId(p.oleh_id);
  const pem = kunciEmail(p.email);
  if (!(uid || uem) || !(pid || pem)) return true;
  return Boolean((uid && pid && uid === pid) || (uem && pem && uem === pem));
}

// Label `validasi_log[].aksi`. SATU peta — aksi baru yang ditulis backend tapi
// lupa didaftarkan di sini bocor ke layar sebagai kunci mentahnya, dan itu
// langsung kelihatan salah (tes paritas juga menagihnya).
export const AKSI_VALIDASI = {
  ajukan_batal: "Diajukan batal validasi",
  setujui_batal: "Batal validasi disetujui SPV",
  tolak_batal: "Pengajuan batal ditolak SPV",
  lepas_langsung: "Centang Valid dilepas SPV",
};

/** Label satu baris Riwayat Validasi. Entri LAMA (sebelum 22 Sep) tidak punya
 *  `aksi` — labelnya diturunkan dari `dari -> ke`, tanpa migrasi data. */
export function labelRiwayatValidasi(v) {
  const x = v || {};
  if (x.aksi) {
    if (x.aksi === "lepas_langsung" && x.ke === "investigasi") return "Valid dicabut SPV, ditandai investigasi";
    return AKSI_VALIDASI[x.aksi] || x.aksi;
  }
  const dari = x.dari || "belum";
  const ke = x.ke || "belum";
  if (ke === "valid") return dari === "valid" ? "Dicentang ulang Valid" : "Ditandai Valid";
  if (ke === "investigasi") return "Ditandai perlu investigasi";
  if (ke === "belum" && dari === "valid") return "Centang Valid dilepas";
  if (ke === "belum" && dari === "investigasi") return "Tanda investigasi dilepas";
  return `${dari} → ${ke}`;
}
